import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-email-with-otp',
  template: `
    <div class="relative flex items-center">
      @if (emailVerified) {
        <i
          class="pi pi-verified text-green-700 z-50 absolute left-2"
          pTooltip="Email verified"
          tooltipPosition="top"
        ></i>
      }
      <input
        type="text"
        pInputText
        [formControl]="emailFormControl"
        class="w-full"
        [ngClass]="{ 'pl-7': emailVerified }"
      />

      @if (emailValid) {
        <button
          type="button"
          class="px-2 py-2 cursor-pointer absolute right-3  text-sm text-primary z-50"
          pTooltip="Email me one time password"
          tooltipPosition="top"
          tooltipStyleClass="text-center"
          (click)="sendOtp()"
        >
          Send Code
        </button>
      }
    </div>

    @if (showOtp) {
      <div class="mt-3">
        <label class="w-full block mb-1">
          Email Verification Code
          <span aria-hidden="true">*</span>
        </label>

        <div class="w-full">
          <div class="w-2/3">
            <p-inputotp [formControl]="codeFormControl" [integerOnly]="true" styleClass="h-10 w-12" size="small" />
          </div>
          <small class="text-gray-500 mt-1"> Please check your email inbox for a 4-digit verification code. </small>
        </div>
      </div>
    }
  `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyEmailWithOtpComponent extends FieldType implements OnInit {
  emailFormControl: FormControl = new FormControl();
  codeFormControl: FormControl = new FormControl();

  get control(): FormControl {
    return this.formControl as FormControl;
  }

  showOtp: boolean = false;
  email: string = '';
  code: string = '';
  emailValid: boolean = false;

  get emailVerified(): boolean {
    return this.props['emailVerified'] ?? false;
  }

  constructor() {
    super();
  }

  ngOnInit() {
    const { email, code } = this.formControl.value ?? { email: '', code: '' };

    if (email) {
      this.email = email;
      this.emailFormControl.setValue(email, { emitEvent: false });
      this.validateEmail();
    }

    if (code) {
      this.code = code;
      this.codeFormControl.setValue(code, { emitEvent: false });
    }

    this.emailFormControl.valueChanges.subscribe((value) => {
      this.email = value;
      if (this.email) {
        this.validateEmail();
      }
      this._updateFormControlValues();
    });

    this.codeFormControl.valueChanges.subscribe((value) => {
      this.code = value;
      this._updateFormControlValues();
    });
  }

  validateEmail() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.emailValid = emailRegex.test(this.email);
  }

  sendOtp() {
    this.showOtp = true;

    if (this.props.click) {
      this.props.click(this);
    }
  }

  private _updateFormControlValues() {
    this.formControl.setValue({
      email: this.email,
      code: this.code,
    });
  }
}
